import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DeleteJobSiteDialogComponent } from './delete-job-site-dialog.component';

@NgModule({
    declarations: [DeleteJobSiteDialogComponent],
    imports: [CommonModule, TwcModule, TranslateModule, ReactiveFormsModule],
    exports: [DeleteJobSiteDialogComponent],
})
export class DeleteJobSiteModule {}
